module.exports = __webpack_public_path__ + "img/invalid.eebc51a3.svg";